import {
    serializable,
    DynamicFormControlLayout,
    DynamicInputModel,
    DynamicInputModelConfig,
	MATCH_VISIBLE,
} from "@ng-dynamic-forms/core";
import { Model_WorkflowComponent, CODE_WORKFLOW_COMPONENT, TYPE_DATASOURCE, TYPE_DEFAULT_VALUE, TYPE_WORKFLOW_COMPONENT_OBSERVER, EXPRESSION_FIELD_SCOPE, FONCTION_WORKFLOW_COMPONENT_OPTIONS } from 'src/app/app.models';
import { COMPONENT_MODE, COMPONENT_UI } from '../workflow-components.models';
import { WorkflowComponentBuilderOptions } from '../workflow-components.service';
  
export interface ExpressionEvaluatorModelConfig extends DynamicInputModelConfig {
	componentMode: COMPONENT_MODE;
}
  
export class ExpressionEvaluatorModel extends DynamicInputModel {
	@serializable() readonly type: string = 'expression_evaluator'; 
	componentMode: COMPONENT_MODE;
	componentUI: COMPONENT_UI;

	constructor(config: ExpressionEvaluatorModelConfig, layout?: DynamicFormControlLayout) {
		super(config, layout);
		this.componentMode = config.componentMode;
		this.componentUI = COMPONENT_UI.IONIC;
	}

	static initModel(_component: Model_WorkflowComponent): ExpressionEvaluatorModel {
		const formModel = new ExpressionEvaluatorModel({
			id: _component.ID,
			name: _component.ID,
			label: _component.LABEL,
			value: _component.DEFAULT_VALUE,
			required: _component.IS_REQUIRED,
			readOnly: _component.IS_READONLY,
			hidden: _component.IS_VISIBLE !== undefined ? _component.IS_VISIBLE === false : false,
			validators: _component.CUSTOM_VALIDATORS,
			componentMode: _component.COMPONENT_MODE,
			additional: _component,
			relations: _component.RELATIONS
		});
		return formModel;
	}

	static getProperties(_options?: WorkflowComponentBuilderOptions): Model_WorkflowComponent {
		return {
			ID: 'expression_evaluator',
			CODE: CODE_WORKFLOW_COMPONENT.EXPRESSION_EVALUATOR,
			ICON: 'text-outline',
			LABEL: 'Expression Evaluator',
			PROPERTIES: [
				{ ID: 'GUID', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'GUID', IS_VISIBLE: false },
				{ ID: 'INDEX', CODE: CODE_WORKFLOW_COMPONENT.NUMERIC_TEXTBOX, LABEL: 'Index', DEFAULT_VALUE: 1 },
				{ ID: 'ID', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Identifiant', IS_REQUIRED: true, CUSTOM_VALIDATORS: [{ VALIDATOR_NAME: 'no_whitespace' }] },
				{ ID: 'LABEL', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Libellé', IS_REQUIRED: true },
				{ ID: 'IS_VISIBLE', CODE: CODE_WORKFLOW_COMPONENT.TOGGLE, LABEL: 'Est Visible ?', DEFAULT_VALUE: true },
				{ ID: 'IS_REQUIRED', CODE: CODE_WORKFLOW_COMPONENT.TOGGLE, LABEL: 'Est Requis ?' },
				{ ID: 'EXPRESSION_VALUE', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Expression', IS_REQUIRED: true },
				{ ID: 'HELP', CODE: CODE_WORKFLOW_COMPONENT.LABEL, LABEL: '<div><strong>Fonctions disponibles: </strong><ul><li>CONCAT(...args)</li><li>DATE(format: string)</li><li>PADLEFT(str, length, char)</li><li>TIMESTAMP()</li><li>GENCODE(length)</li><li>UPPERCASE(str)</li><li>LOWERCASE(str)</li></ul></div>' },
			]
		};
	}
}
  